import HeroIcon from './HeroIcon';

const ICON_LIST = [
  // Generic
  "DocumentText",
  "Mail",
  "Clock",
  "Tag",
  "Bell",
  "Flag",
  "Exclamation",
  // Use Cases
  "ReceiptTax", // Invoices
  "AcademicCap", // School
  "Beaker",
  "BookOpen", // Libraries
  "BadgeCheck",
  "PresentationChartLine",
  "Briefcase",
  "ClipboardList",
  "Home", // Real Estate
  "Scale",
  "Truck", // Logistics
  "Film",
  "Identification", // Onboarding
  "CurrencyDollar",
  "ShieldCheck",
  "Qrcode",
  // Fun
  "EmojiHappy",
  "Heart",
  "Star",
  "Cloud",
  "LightningBolt",
  "Fire",
  "Globe",
  "Cake",

  "Adjustments",
  "Annotation",
  "Archive",
  "ArrowCircleDown",
  "ArrowCircleLeft",
  "ArrowCircleRight",
  "ArrowCircleUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowNarrowDown",
  "ArrowNarrowLeft",
  "ArrowNarrowRight",
  "ArrowNarrowUp",
  "ArrowRight",
  "ArrowSmDown",
  "ArrowSmLeft",
  "ArrowSmRight",
  "ArrowSmUp",
  "ArrowUp",
  "ArrowsExpand",
  "AtSymbol",
  "Backspace",
  "Ban",
  "BookmarkAlt",
  "Bookmark",
  "Calculator",
  "Calendar",
  "Camera",
  "Cash",
  "ChartBar",
  "ChartPie",
  "ChartSquareBar",
  "ChatAlt2",
  "ChatAlt",
  "Chat",
  "CheckCircle",
  "Check",
  "ChevronDoubleDown",
  "ChevronDoubleLeft",
  "ChevronDoubleRight",
  "ChevronDoubleUp",
  "ChevronDown",
  "ChevronLeft",
  "ChevronRight",
  "ChevronUp",
  "Chip",
  "ClipboardCheck",
  "ClipboardCopy",
  "Clipboard",
  "CloudDownload",
  "CloudUpload",
  "Code",
  "Cog",
  "Collection",
  "ColorSwatch",
  "CreditCard",
  "CubeTransparent",
  "Cube",
  "CurrencyBangladeshi",
  "CurrencyEuro",
  "CurrencyPound",
  "CurrencyRupee",
  "CurrencyYen",
  "CursorClick",
  "Database",
  "DesktopComputer",
  "DeviceMobile",
  "DeviceTablet",
  "DocumentAdd",
  "DocumentDownload",
  "DocumentDuplicate",
  "DocumentRemove",
  "DocumentReport",
  "DocumentSearch",
  "Document",
  "DotsCircleHorizontal",
  "DotsHorizontal",
  "DotsVertical",
  "Download",
  "Duplicate",
  "EmojiSad",
  "ExclamationCircle",
  "ExternalLink",
  "EyeOff",
  "Eye",
  "FastForward",
  "Filter",
  "FingerPrint",
  "FolderAdd",
  "FolderDownload",
  "FolderOpen",
  "FolderRemove",
  "Folder",
  "Gift",
  "GlobeAlt",
  "Hand",
  "Hashtag",
  "InboxIn",
  "Inbox",
  "InformationCircle",
  "Key",
  "Library",
  "LightBulb",
  "Link",
  "LocationMarker",
  "LockClosed",
  "LockOpen",
  "Login",
  "Logout",
  "MailOpen",
  "Map",
  "MenuAlt1",
  "MenuAlt2",
  "MenuAlt3",
  "MenuAlt4",
  "Menu",
  "Microphone",
  "MinusCircle",
  "MinusSm",
  "Minus",
  "Moon",
  "MusicNote",
  "Newspaper",
  "OfficeBuilding",
  "PaperAirplane",
  "PaperClip",
  "Pause",
  "PencilAlt",
  "Pencil",
  "PhoneIncoming",
  "PhoneMissedCall",
  "PhoneOutgoing",
  "Phone",
  "Photograph",
  "Play",
  "PlusCircle",
  "PlusSm",
  "Plus",
  "PresentationChartBar",
  "Printer",
  "Puzzle",
  "QuestionMarkCircle",
  "ReceiptRefund",
  "Refresh",
  "Reply",
  "Rewind",
  "Rss",
  "SaveAs",
  "Save",
  "Scissors",
  "SearchCircle",
  "Search",
  "Selector",
  "Server",
  "Share",
  "ShieldExclamation",
  "ShoppingBag",
  "ShoppingCart",
  "SortAscending",
  "SortDescending",
  "Sparkles",
  "Speakerphone",
  "StatusOffline",
  "StatusOnline",
  "Stop",
  "Sun",
  "Support",
  "SwitchHorizontal",
  "SwitchVertical",
  "Table",
  "Template",
  "Terminal",
  "ThumbDown",
  "ThumbUp",
  "Ticket",
  "Translate",
  "Trash",
  "TrendingDown",
  "TrendingUp",
  "Upload",
  "UserAdd",
  "UserCircle",
  "UserGroup",
  "UserRemove",
  "User",
  "Users",
  "Variable",
  "VideoCamera",
  "ViewBoards",
  "ViewGridAdd",
  "ViewGrid",
  "ViewList",
  "VolumeOff",
  "VolumeUp",
  "Wifi",
  "XCircle",
  "X",
  "ZoomIn",
  "ZoomOut",
];

interface Props {
  value: string;
  onChange: (color: string) => void;
  selectColour: string;
}

function IconPickerField(props: Props) {
  return (
    <div className='flex flex-col flex-wrap h-40 w-full gap-1 overflow-x-scroll'>
      {ICON_LIST.map((icon) => {
        const isSelected = icon === props.value;
        return (
          <div key={icon} className="flex items-center justify-center w-8 h-8 rounded cursor-pointer flex-shrink-0" style={{ color: isSelected ? "white" : "black", backgroundColor: isSelected ? props.selectColour : "white" }} onClick={() => props.onChange(icon)}>
            <HeroIcon icon={icon} className="h-6 w-6" />
          </div>
        );
      })}
    </div>
  );
}

export default IconPickerField;
